export const tokenActions = {
  addToken: 'ADD_TOKEN',
  removeToken: 'REMOVE_TOKEN'
}

export const settingsAction = {
  getAdmins: 'GET_ADMINS',
  getChannels: 'GET_CHANNELS'
}
